module.exports = __webpack_public_path__ + "static/img/rulesup.860799a9.svg";